import { Button, makeStyles } from '@material-ui/core';
import { RemoveCircle, Dangerous } from '@mui/icons-material';
import React, { useContext } from 'react';

import { Colors } from 'src/common/ui/base';
import {
  hideChartElementDialogContent,
  clearChartElementDialogContent,
} from 'src/nightingale/components/ChartInteraction/ChartInteractionConfirmDialogContent';
import { ChartInteractionConfirmDialogContext } from 'src/nightingale/components/ChartInteraction/ChartInteractionConfirmDialogContext';

/**
 * Styles
 */
const useStyles = makeStyles({
  iconButton: {
    alignItems: 'center',
    backgroundColor: Colors.Peach3,
    border: 'none',
    borderRadius: 0,
    color: Colors.White,
    cursor: 'pointer',
    fontFamily: '"Nunito", "Nunito Sans"',
    fontSize: 12,
    fontWeight: 'bold',
    justifyContent: 'center',
    letterSpacing: 1.12,
    margin: '16px 0 0 16px',
    padding: '8px 16px',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: Colors.Peach3,
    },
  },
});

export const ShortcutButtons = ({
  hideFlow,
  clearElement,
}: {
  hideFlow?: () => void;
  clearElement?: () => void;
}) => {
  const { showDialog } = useContext(ChartInteractionConfirmDialogContext);

  const styles = useStyles();
  return (
    <div>
      {hideFlow && (
        <Button
          data-testid="shortcut-hide-button"
          onClick={() => hideChartElementDialogContent(showDialog, hideFlow)}
          classes={{ root: styles.iconButton }}
          startIcon={<RemoveCircle />}
        >
          Hide
        </Button>
      )}
      {clearElement && (
        <Button
          data-testid="shortcut-clear-button"
          onClick={() => clearChartElementDialogContent(showDialog, clearElement)}
          classes={{ root: styles.iconButton }}
          startIcon={<Dangerous />}
        >
          Clear
        </Button>
      )}
    </div>
  );
};
